import { ILocalStorageRepository } from "@/domain/repositories/storage.repository";

export const LocalStorage: ILocalStorageRepository = {
  get(key: string): unknown {
    const serializedValue = localStorage.getItem(key);
    if (
      !serializedValue ||
      serializedValue === "undefined" ||
      serializedValue === "null"
    ) {
      return null;
    }
    return JSON.parse(serializedValue);
  },
  set(key: string, value: unknown): void {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  },
  remove(key: string): void {
    localStorage.removeItem(key);
  },
  clear(): void {
    localStorage.clear();
  },
};
